export const locale = {
  lang: "fr-CA",
  data: {
    ORDER_PRODUCTS: {
      TITLE: "Ajouter un produit",
      TITLE_CREATE: "Ajouter un produit",
      LEFT_LIST_LABEL: "Glisser et déposer ou utiliser le bouton + pour ajouter des produits",
      RIGHT_LIST_LABEL: "Liste des produits à ajouter",
      CREATE_PRODUCT: "Créer un produit",
      SEARCH: "recherche par nom interne, nom externe ou code de produit",
      SEARCH_PRODUCT: "Effectuez une recherche de votre produit.",
      CATEGORY_FILTER: "Catégorie de produit",
      TAGS_FILTER: "Tags",
      NO_SEARCH_RESULTS_LINE1: "Aucun résultat pour votre recherche.",
      NO_SEARCH_RESULTS_LINE2: "Veuillez essayer autre chose.",
      GROUP_NAME: "Nom de la sélection",
      CHOICE_REQUIRED_NO_SKIP: "Choix obligatoire",
      UPSALE_TITLE: "Ajouter des produits en vente incitative",
      ORIGINAL_PRICE: "Prix original",
      NEW_PRICE: "Nouveau prix",
    },
  },
};
